import { render, staticRenderFns } from "./TermsCondition.vue?vue&type=template&id=2d2fa931&"
import script from "./TermsCondition.vue?vue&type=script&lang=js&"
export * from "./TermsCondition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports